import firebaseApp from "@/firebase/init";
import "firebase/auth";

export default firebaseApp.auth();
